/* MEALUP design system: the selected flavor takes over the product page.
   Sets data-flavor on <html>; the flavor tokens in mu-site.css do the rest.
   The header stays house (it uses the fixed house colors). */
(function () {
  var FLAVORS = [
    ['cheddar', /cheddar|чедър/i],
    ['parmesan', /parmesan|italian|пармезан/i],
    ['truffle', /truffle|трюф/i],
    ['unflavored', /unflavored|без вкус|неовкус/i]
  ];

  function keyFor(text) {
    if (!text) return null;
    for (var i = 0; i < FLAVORS.length; i++) {
      if (FLAVORS[i][1].test(text)) return FLAVORS[i][0];
    }
    return null;
  }

  function setFlavor(key) {
    if (!key) return;
    var root = document.documentElement;
    if (root.getAttribute('data-flavor') !== key) root.setAttribute('data-flavor', key);
    packFirst(key);
  }

  // The big first gallery image is "the first item in the list" (Sense CSS). The new flavor's pack photo moves to the
  // front at once, so it never shows as a small tile in the moment before Sense re-renders the gallery.
  function packFirst(key) {
    var lists = document.querySelectorAll('.product__media-list, .thumbnail-list');
    for (var l = 0; l < lists.length; l++) {
      var items = lists[l].querySelectorAll(':scope > li[data-mu-pack="' + key + '"]');
      for (var i = 0; i < items.length; i++) {
        var img = items[i].querySelector('img');
        if (!img || (img.getAttribute('src') || '').indexOf('mealup-' + key + '-pack') === -1) continue;
        img.loading = 'eager';
        if (lists[l].firstElementChild !== items[i]) lists[l].insertBefore(items[i], lists[l].firstElementChild);
        break;
      }
    }
  }

  function variantText(variant) {
    if (!variant) return '';
    return [variant.title, variant.option1, variant.option2, variant.option3].join(' ');
  }

  // Instant feedback: the radio flips before the section re-renders.
  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!input || !input.matches) return;
    if (input.matches('.product-form__input input[type="radio"], .product-form__input select, select.select__select')) {
      var value = input.tagName === 'SELECT' ? input.options[input.selectedIndex].text : input.value;
      setFlavor(keyFor(value));
    }
  });

  // Source of truth: the variant Sense publishes after it switches.
  document.addEventListener('DOMContentLoaded', function () {
    if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS) {
      subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        if (event && event.data) setFlavor(keyFor(variantText(event.data.variant)));
      });
    }
  });
})();
